import { useMemo } from 'react';
import { TPAPlnAnalysisData } from '@src/types';

export const usePAPlnAnalysis = (data: TPAPlnAnalysisData[]) => {
  const totals = useMemo(() => {
    return {
      total_pa_accounts: data.reduce(
        (sum, row) => sum + (parseFloat(row.total_pa_accounts) || 0),
        0
      ),
      total_payouts: data.reduce(
        (sum, row) => sum + (parseFloat(row.total_payouts) || 0),
        0
      ),
      accounts_5_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_5_days) || 0),
        0
      ),
      users_5_days: data.reduce((sum, row) => sum + (row.users_5_days || 0), 0),
      accounts_10_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_10_days) || 0),
        0
      ),
      users_10_days: data.reduce(
        (sum, row) => sum + (row.users_10_days || 0),
        0
      ),
      accounts_15_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_15_days) || 0),
        0
      ),
      users_15_days: data.reduce(
        (sum, row) => sum + (row.users_15_days || 0),
        0
      ),
      accounts_20_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_20_days) || 0),
        0
      ),
      users_20_days: data.reduce(
        (sum, row) => sum + (row.users_20_days || 0),
        0
      ),
      accounts_25_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_25_days) || 0),
        0
      ),
      users_25_days: data.reduce(
        (sum, row) => sum + (row.users_25_days || 0),
        0
      ),
      accounts_30_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_30_days) || 0),
        0
      ),
      users_30_days: data.reduce(
        (sum, row) => sum + (row.users_30_days || 0),
        0
      ),
      accounts_60_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_60_days) || 0),
        0
      ),
      users_60_days: data.reduce(
        (sum, row) => sum + (row.users_60_days || 0),
        0
      ),
      accounts_90_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_90_days) || 0),
        0
      ),
      users_90_days: data.reduce(
        (sum, row) => sum + (row.users_90_days || 0),
        0
      ),
      accounts_120_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_120_days) || 0),
        0
      ),
      users_120_days: data.reduce(
        (sum, row) => sum + (row.users_120_days || 0),
        0
      ),
      accounts_150_days: data.reduce(
        (sum, row) => sum + (parseFloat(row.accounts_150_days) || 0),
        0
      ),
      users_150_days: data.reduce(
        (sum, row) => sum + (row.users_150_days || 0),
        0
      ),
    };
  }, [data]);

  const percentageData = useMemo(() => {
    if (totals.total_pa_accounts === 0) return null;

    return {
      label: '% OF TOTAL PA ACCOUNTS',
      days_5: (
        (totals.accounts_5_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_10: (
        (totals.accounts_10_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_15: (
        (totals.accounts_15_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_20: (
        (totals.accounts_20_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_25: (
        (totals.accounts_25_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_30: (
        (totals.accounts_30_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_60: (
        (totals.accounts_60_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_90: (
        (totals.accounts_90_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_120: (
        (totals.accounts_120_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
      days_150: (
        (totals.accounts_150_days / totals.total_pa_accounts) *
        100
      ).toFixed(2),
    };
  }, [totals]);

  const dataWithTotals = useMemo(() => {
    return [...data, {} as TPAPlnAnalysisData];
  }, [data]);

  return {
    totals,
    percentageData,
    dataWithTotals,
  };
};
